module.exports = __webpack_public_path__ + "web-icons.8ff8ffa1813a583463bf.eot";


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Partners-Pipeline/src/assets/fonts/web-icons/web-icons.eot
// module id = ../../../../../src/assets/fonts/web-icons/web-icons.eot
// module chunks = styles